<app-modal title="Recebimento" [form]="form" (save)="onSave($event)">
  <form [formGroup]="form">
    <div class="tds-row">
      <app-input
        label="Entrada"
        formControlName="dataEntrada"
        [readOnly]="true"
      ></app-input>
      <app-input
        label="Saída"
        formControlName="dataSaida"
        [readOnly]="true"
      ></app-input>
      <app-select
        label="Fase"
        [options]="data.faseList"
        formControlName="fase"
      ></app-select>
      <app-select
        label="Local *"
        [options]="data.localList"
        formControlName="local"
      ></app-select>
    </div>

    <div class="tds-row">
      <app-input
        label="CPF"
        formControlName="driverId"
        cpfMask
        [readOnly]="true"
      ></app-input>
      <app-input
        label="Senha"
        formControlName="senha"
        maxLength="10"
        [readOnly]="true"
      ></app-input>
      <app-input
        label="Celular"
        formControlName="celular"
        [readOnly]="true"
      ></app-input>
      <app-input label="Nota fiscal" formControlName="notaFiscal"></app-input>
    </div>

    <div class="tds-row">
      <app-input label="Fornecedor" formControlName="fornecedor"></app-input>
      <app-input label="Volume" formControlName="volume"></app-input>
      <app-select
        label="Direcionamento"
        [options]="direcionamentoOptions"
        formControlName="direcionamento"
      ></app-select>
      <app-input label="Registro" formControlName="registro"></app-input>
    </div>

    <div class="tds-row">
      <app-input
        label="Quantidade linhas"
        formControlName="quantidadeLinhas"
      ></app-input>
      <app-input
        label="Responsável"
        formControlName="responsavelInterno"
      ></app-input>
      <app-input label="Observação" formControlName="observacao"></app-input>
    </div>

    <div class="tds-row">
      <div class="checkboxes-container">
        <tds-checkbox formControlName="critico" checkboxId="critico-checkbox">
          <div slot="label">Crítico</div>
        </tds-checkbox>
        <tds-checkbox formControlName="milkrun" checkboxId="milkrun-checkbox">
          <div slot="label">Milkrun</div>
        </tds-checkbox>
        <tds-checkbox
          formControlName="controlCenter"
          checkboxId="controcenter-checkbox"
        >
          <div slot="label">Control Center</div>
        </tds-checkbox>
      </div>
    </div>
  </form>
</app-modal>
